export function staticAsset(path) {
  const version = STATIC_ASSET_VERSIONS[path];
  return version ? `${path}?v=${version}` : path;
}
